import qs from 'qs';
import api, { IDataRequest, IDataResponse } from "src/framework/providers/api";
import AProvider from "src/framework/providers/AProvider";

export interface ImpostoItem {
    id: number
    estado_id: string
    icms_tusd: number
    isencao_icms_tusd: number
    icms_te: number
    isencao_icms_te: number
    pis: number
    created_at: string
    updated_at: string
    user_guilted_id: number
}

class RoiPaybackImpostosProvider extends AProvider {
    constructor() {
        super("/cadastros/roipayback_impostos");
    }

    async buscarImpostosPorEstado(estado_id: string): Promise<ImpostoItem[]> {
        const qString = { estado_id}
        const queryString = qs.stringify(qString)
        const url = `${this.path}?${queryString}`
        const request: IDataRequest = { url }
        const response: IDataResponse<ImpostoItem[]> = await api.get(request);
        return response.data
    }
}

export { RoiPaybackImpostosProvider }